import styled from 'styled-components'

export const AdminLoginDiv = styled.div`
display:flex;
justify-content:center;
align-items:center;
min-height:100vh;

.inner-container{
    display:flex;
    justify-content:center;
    align-items:center;
    text-align:center;
    align-content:center;

    img{
        width:100px;
    }
    h3{
        font-weight: bold;
        font-size: 30px;
        line-height: 37px;
        color: #1E90FF;
    }
}   
.right-div{
    display:flex;
    flex-direction:column;
    input{
        :focus{
            box-shadow:none;
            border:none;
            border-style:none;
        }
        background: rgba(229, 229, 229, 0.4);
        height:60px;
        margin-top:30px;
    }
    button{
        height:60px;
        width:100%;
        background: #1DCDFE;
        color:#fff;
        :focus{
            box-shadow:none;
        }

    }  
    
}
`